import { createFileRoute } from "@tanstack/react-router"

import { PersonalInformationRouteComponent } from "@/routes/_authenticated/account/personal-information"

export const Route = createFileRoute(
  "/qr/$qrLookupID/_authenticated/account/personal-information"
)({
  staticData: {
    pageName: "Personal Information",
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <PersonalInformationRouteComponent />
}
